import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-explizite-freigabe-festlegen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichExpliziteFreigabeFestlegenEffects {

    FunktionsbereichExpliziteFreigabeFestlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_EXPLIZITE_FREIGABE_FESTLEGEN),
        mergeMap((x: ac.PostFunktionsbereichExpliziteFreigabeFestlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichExpliziteFreigabeFestlegen(x.funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichExpliziteFreigabeFestlegenErfolgreichAction(result, x.funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichExpliziteFreigabeFestlegenFehlerAction(error, x.funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
